import React from 'react';
import {Container, Divider, Message} from 'semantic-ui-react';

import Auth from './Auth';

class AuthContainer extends React.Component {

  render() {
    return (
      <Container text>
        <Divider hidden />
        {(this.props.warningMessage)
          ? <Message warning>Please <strong>log in</strong> or <strong>sign up</strong> to view this page: "{this.props.match.url}" - Thank you.
            </Message>
          : ''}
        <Divider hidden />
        <Auth />
      </Container>
    );
  }

}

export default AuthContainer;



// WEBPACK FOOTER //
// ./src/components/AuthContainer.js